import {
  SET_DASHBOARD_REPORT_DATA,
} from "./mutations";

const initialState = {
  dashboardReportData: {},
};

const reportsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_DASHBOARD_REPORT_DATA:
      return { ...state, dashboardReportData: payload }

    default:
      return state;
  }
};

export default reportsReducer;